const WEB_AWESOME_COMPONENTS = [
  'wa-badge',
  'wa-button',
  'wa-callout',
  'wa-card',
  'wa-checkbox',
  'wa-dialog',
  'wa-divider',
  'wa-drawer',
  'wa-icon',
  'wa-input',
  'wa-option',
  'wa-select',
  'wa-skeleton',
] as const;

const READY_TIMEOUT_MS = 8_000;

let readyPromise: Promise<void> | null = null;

function withTimeout<T>(promise: Promise<T>, ms: number): Promise<T | void> {
  return Promise.race([
    promise,
    new Promise<void>((resolve) => {
      window.setTimeout(resolve, ms);
    }),
  ]);
}

/** Preload WA custom elements and resolve once they are defined (or after timeout). */
export function ensureWebAwesomeReady(): Promise<void> {
  if (!readyPromise) {
    const mount = document.querySelector('#wa-initializer');
    if (mount && !mount.hasChildNodes()) {
      mount.innerHTML = WEB_AWESOME_COMPONENTS.map((name) => `<${name}></${name}>`).join('');
    }

    readyPromise = withTimeout(
      Promise.all(WEB_AWESOME_COMPONENTS.map((name) => customElements.whenDefined(name))).then(
        () => undefined,
      ),
      READY_TIMEOUT_MS,
    ).then(() => undefined);
  }

  return readyPromise;
}

export function markAppReady(root: Element | null): void {
  root?.classList.add('wa-ready');
}
